import moment from "moment";

const displayNotifTime = ({ hour, minute }) => {
  return moment().hour(hour).minute(minute).format("kk:mm");
};

export default displayNotifTime;
